import { makeObservable, observable } from 'mobx'
import * as R from 'ramda'

class QueryRunnerStore {
    @observable loading = true

    customQueries = []

    @observable queryParams = []

    @observable showDetails = false

    @observable error

    @observable response

    constructor(store) {
        this.appStore = store
        makeObservable(this)
    }

    init = async () => {
        this.customQueries = await this.appStore.http.get('/dataviewer/queryrunner')
        this.loading = false
    }

    changeParam = ({ value, name }) => {
        console.log('changeParam', name, value)
        this.formParams[name] = value
    }

    run = async () => {
        this.error = false
        this.response = ''

        try {
            this.response = await this.appStore.http.post(`/dataviewer/queryrunner/${this.selectedQuery}`, JSON.stringify(this.formParams))
        } catch (e) {
            console.log(e)
            this.error = true
            const response = typeof e === 'string'
                ? e
                : R.pathOr('Error executing the request', ['msg'], e)

            console.log('run', response, typeof e)
            this.response = String(response)
        }
    }

    changeQuery = async ({ value }) => {
        this.selectedQuery = value
        this.error = false
        this.response = ''
        this.showDetails = false
        this.formParams = {}
        const { description, params, type } = await this.appStore.http.get(`/dataviewer/queryrunner/${value}`)
        params.forEach(({ key, value, type }) => {
            const id = key || value
            if (type === 'checkbox') {
                this.formParams[id] = false
            } else {
                this.formParams[id] = ''
            }
        })

        if (type === 'export') {
            this.formParams.download = true
        }

        this.description = description
        this.queryParams = params

        this.showDetails = true
    }
}

export default QueryRunnerStore
